import { Component, Input, OnInit } from '@angular/core';

import { Blog } from '@sparro/app/core/models/blog.model';
import { User } from '@sparro/app/core/models/user.model';

import { BlogService } from '@sparro/app/core/api/blog/blog.service';
import { UserService } from '@sparro/app/core/api/user/user.service';

import { ALLOWED_HOSTS } from '@sparro/app/core/config/constants.config';
import { environment } from '@sparro/env/environment';

@Component({
  selector: 'uni-blog-cards-group',
  templateUrl: './blog-cards-group.component.html',
  styleUrls: ['./blog-cards-group.component.scss']
})
export class BlogCardsGroupComponent implements OnInit {
  @Input() blogs: Blog[] = [];
  @Input() host: ALLOWED_HOSTS;
  @Input() display: ('grid' | 'breakpoint') = 'grid';
  @Input() self: boolean = false;
  @Input() showCardOptions: boolean = true;
  @Input() organization: string;
  @Input() showCreate: boolean = false;
  @Input() dialogOpenable: boolean = true;

  blog: Blog;
  user: User;

  constructor(
    private userService: UserService,
    private blogService: BlogService
  ) { }

  ngOnInit(): void {
    this.getAuthUser();
  }

  getAuthUser(): void {
    this.userService.userInitialized.subscribe(
      (initialized: boolean) => {
        if (initialized) {
          this.userService.user.subscribe(
            (user: User) => {
              this.user = user;
            });
        }
      });
    }

  removedBlog(uuid: string): void {
    this.blogs = this.blogs.filter((blog, index) => {
      return blog.uuid !== uuid;
    });
  }

  getNewPostUrl(): string {
    return `${environment.postUrl}edit/`;
  }

  getNewBlogLink(): string {
    return `${environment.postUrl}edit/`;
  }
}
